import React, { useState, useEffect } from 'react';
import { Plus, Edit2, Trash2, ClipboardList, GripVertical, X } from 'lucide-react';
import api from '../services/api';

const emptyPergunta = { rotulo:'', descricao:'', obrigatoria:false, elimina_se_sim:[], elimina_se_nao:[], reter_se_sim:false, reter_se_nao:false, retencao_instrucao:'' };

export default function Formularios() {
    const [formularios, setFormularios] = useState([]);
    const [funcs, setFuncs] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editing, setEditing] = useState(null);
    const [salvando, setSalvando] = useState(false);
    const emptyForm = { funcionario_id:'', ativo:true, titulo:'Formulario de triagem', instrucao_final:'', perguntas:[{...emptyPergunta}] };
    const [form, setForm] = useState(emptyForm);

    useEffect(() => { load(); }, []);

    const load = async () => {
        try {
            const [fo, f] = await Promise.all([api.get('/api/formularios'), api.get('/api/funcionarios')]);
            setFormularios(fo.data);
            setFuncs(f.data);
        } catch(e) { console.error(e); }
    };

    const openNew = () => {
        setEditing(null);
        setForm({...emptyForm, funcionario_id: funcs.length>0?funcs[0].id:'', perguntas:[{...emptyPergunta}]});
        setShowModal(true);
    };

    const openEdit = (fo) => {
        setEditing(fo);
        setForm({ funcionario_id: fo.funcionario_id, ativo: fo.ativo, titulo: fo.titulo, instrucao_final: fo.instrucao_final || '', perguntas: (fo.perguntas && fo.perguntas.length ? fo.perguntas : [{...emptyPergunta}]).map(p=>({...emptyPergunta, ...p, elimina_se_sim: p.elimina_se_sim||[], elimina_se_nao: p.elimina_se_nao||[], reter_se_sim: !!p.reter_se_sim, reter_se_nao: !!p.reter_se_nao, retencao_instrucao: p.retencao_instrucao||''})) });
        setShowModal(true);
    };

    const setPergunta = (i, campo, valor) => {
        const ps = form.perguntas.map((p, idx) => idx===i ? {...p, [campo]: valor} : p);
        setForm({...form, perguntas: ps});
    };

    const addPergunta = () => setForm({...form, perguntas:[...form.perguntas, {...emptyPergunta}]});
    const delPergunta = (i) => setForm({...form, perguntas: form.perguntas.filter((_, idx)=>idx!==i)});
    const toggleElimina = (i, lado, alvo) => {
        const ps = form.perguntas.map((p, idx) => {
            if (idx !== i) return p;
            const lista = [...(p[lado]||[])];
            const pos = lista.indexOf(alvo);
            if (pos === -1) lista.push(alvo); else lista.splice(pos, 1);
            return {...p, [lado]: lista};
        });
        setForm({...form, perguntas: ps});
    };

    const movePergunta = (i, dir) => {
        const ps = [...form.perguntas];
        const j = i + dir;
        if (j < 0 || j >= ps.length) return;
        [ps[i], ps[j]] = [ps[j], ps[i]];
        setForm({...form, perguntas: ps});
    };

    const salvar = async () => {
        if (!form.funcionario_id) { alert('Escolha o agente.'); return; }
        const validas = form.perguntas.filter(p => p.rotulo.trim() !== '');
        if (!validas.length) { alert('Cadastre ao menos uma pergunta.'); return; }
        setSalvando(true);
        try {
            await api.post('/api/formularios', {...form, perguntas: validas});
            setShowModal(false);
            load();
        } catch(e) { alert('Erro ao salvar: ' + (e.response?.data?.erro || e.message)); }
        setSalvando(false);
    };

    const excluir = async (fo) => {
        if (!window.confirm('Excluir o formulario de ' + fo.funcionario_nome + '?')) return;
        try { await api.delete('/api/formularios/' + fo.id); load(); }
        catch(e) { alert('Erro: ' + (e.response?.data?.erro || e.message)); }
    };

    const toggleAtivo = async (fo) => {
        try {
            await api.post('/api/formularios', { funcionario_id: fo.funcionario_id, ativo: !fo.ativo, titulo: fo.titulo, instrucao_final: fo.instrucao_final, perguntas: fo.perguntas });
            load();
        } catch(e) { alert('Erro: ' + (e.response?.data?.erro || e.message)); }
    };

    return (
        <div style={{padding:'24px'}}>
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'24px'}}>
                <div>
                    <h1 style={{fontSize:'24px', fontWeight:'bold', margin:0}}>Formularios</h1>
                    <p style={{color:'#8b8fa3', margin:'4px 0 0'}}>Triagem configuravel por agente - perguntas coletadas e enviadas ao atendente humano</p>
                </div>
                <button onClick={openNew} style={{display:'flex', alignItems:'center', gap:'8px', background:'#6c5ce7', color:'#fff', border:'none', borderRadius:'8px', padding:'10px 16px', cursor:'pointer', fontWeight:600}}>
                    <Plus size={18}/> Novo formulario
                </button>
            </div>

            {formularios.length === 0 && (
                <div style={{textAlign:'center', padding:'60px', color:'#8b8fa3', background:'#141625', borderRadius:'12px'}}>
                    <ClipboardList size={40} style={{marginBottom:'12px', opacity:0.5}}/>
                    <p>Nenhum formulario ainda. Crie o primeiro e vincule a um agente.</p>
                </div>
            )}

            <div style={{display:'grid', gap:'12px'}}>
                {formularios.map(fo => (
                    <div key={fo.id} style={{background:'#141625', borderRadius:'12px', padding:'16px 20px', display:'flex', justifyContent:'space-between', alignItems:'center', border:'1px solid #23263a'}}>
                        <div>
                            <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                                <strong>{fo.titulo}</strong>
                                <span style={{fontSize:'12px', padding:'2px 10px', borderRadius:'10px', background: fo.ativo ? '#1e3a2f' : '#3a1e1e', color: fo.ativo ? '#4ade80' : '#f87171'}}>{fo.ativo ? 'Ativo' : 'Desativado'}</span>
                            </div>
                            <div style={{color:'#8b8fa3', fontSize:'14px', marginTop:'4px'}}>Agente: {fo.funcionario_nome} - {(fo.perguntas||[]).length} pergunta(s)</div>
                        </div>
                        <div style={{display:'flex', gap:'8px'}}>
                            <button onClick={()=>toggleAtivo(fo)} style={{background:'transparent', border:'1px solid #23263a', borderRadius:'8px', padding:'8px 12px', color:'#c8cbe0', cursor:'pointer'}}>{fo.ativo ? 'Desativar' : 'Ativar'}</button>
                            <button onClick={()=>openEdit(fo)} style={{background:'transparent', border:'1px solid #23263a', borderRadius:'8px', padding:'8px', color:'#c8cbe0', cursor:'pointer'}}><Edit2 size={16}/></button>
                            <button onClick={()=>excluir(fo)} style={{background:'transparent', border:'1px solid #23263a', borderRadius:'8px', padding:'8px', color:'#f87171', cursor:'pointer'}}><Trash2 size={16}/></button>
                        </div>
                    </div>
                ))}
            </div>

            {showModal && (
                <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', display:'flex', justifyContent:'center', alignItems:'flex-start', padding:'40px 16px', overflowY:'auto', zIndex:50}}>
                    <div style={{background:'#141625', borderRadius:'12px', padding:'24px', width:'100%', maxWidth:'1100px', border:'1px solid #23263a'}}>
                        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px'}}>
                            <h2 style={{margin:0, fontSize:'18px'}}>{editing ? 'Editar formulario' : 'Novo formulario'}</h2>
                            <button onClick={()=>setShowModal(false)} style={{background:'transparent', border:'none', color:'#8b8fa3', cursor:'pointer'}}><X size={20}/></button>
                        </div>

                        <label style={{display:'block', marginBottom:'6px', fontSize:'14px', color:'#c8cbe0'}}>Agente</label>
                        <select value={form.funcionario_id} onChange={e=>setForm({...form, funcionario_id:e.target.value})}
                            style={{width:'100%', padding:'10px', borderRadius:'8px', background:'#0d0f1a', border:'1px solid #23263a', color:'#fff', marginBottom:'16px'}}>
                            {funcs.map(f => <option key={f.id} value={f.id}>{f.nome}{f.cliente_nome ? ' (' + f.cliente_nome + ')' : ''}</option>)}
                        </select>

                        <label style={{display:'block', marginBottom:'6px', fontSize:'14px', color:'#c8cbe0'}}>Titulo da ficha</label>
                        <input value={form.titulo} onChange={e=>setForm({...form, titulo:e.target.value})}
                            style={{width:'100%', padding:'10px', borderRadius:'8px', background:'#0d0f1a', border:'1px solid #23263a', color:'#fff', marginBottom:'16px', boxSizing:'border-box'}}/>

                        <label style={{display:'block', marginBottom:'6px', fontSize:'14px', color:'#c8cbe0'}}>Perguntas (na ordem da coleta)</label>
                        {form.perguntas.map((p, i) => (
                            <div key={i} style={{background:'#0d0f1a', border:'1px solid #23263a', borderRadius:'8px', padding:'12px', marginBottom:'10px'}}>
                                <div style={{display:'flex', gap:'8px', alignItems:'center', marginBottom:'8px'}}>
                                    <div style={{display:'flex', flexDirection:'column', gap:'2px'}}>
                                        <button onClick={()=>movePergunta(i,-1)} style={{background:'transparent', border:'none', color:'#8b8fa3', cursor:'pointer', padding:0, lineHeight:1}}>▲</button>
                                        <button onClick={()=>movePergunta(i,1)} style={{background:'transparent', border:'none', color:'#8b8fa3', cursor:'pointer', padding:0, lineHeight:1}}>▼</button>
                                    </div>
                                    <span style={{color:'#6c5ce7', fontWeight:700, minWidth:'22px', textAlign:'center'}}>{i+1}</span>
                                    <input placeholder="Pergunta / informacao a coletar (ex: Hospital de preferencia)" value={p.rotulo} onChange={e=>setPergunta(i,'rotulo',e.target.value)}
                                        style={{flex:1, padding:'8px', borderRadius:'6px', background:'#141625', border:'1px solid #23263a', color:'#fff'}}/>
                                    <button onClick={()=>delPergunta(i)} style={{background:'transparent', border:'none', color:'#f87171', cursor:'pointer'}}><Trash2 size={16}/></button>
                                </div>
                                <input placeholder="Detalhe do que perguntar (opcional)" value={p.descricao} onChange={e=>setPergunta(i,'descricao',e.target.value)}
                                    style={{width:'100%', padding:'8px', borderRadius:'6px', background:'#141625', border:'1px solid #23263a', color:'#fff', marginBottom:'8px', boxSizing:'border-box'}}/>
                                <label style={{display:'flex', alignItems:'center', gap:'8px', fontSize:'13px', color:'#c8cbe0', cursor:'pointer'}}>
                                    <input type="checkbox" checked={p.obrigatoria} onChange={e=>setPergunta(i,'obrigatoria',e.target.checked)}/>
                                    Obrigatoria (a ficha nao envia sem esta resposta)
                                </label>
                                {form.perguntas.length > 1 && ['elimina_se_sim','elimina_se_nao'].map(lado => (
                                    <div key={lado} style={{marginTop:'8px', paddingTop:'8px', borderTop:'1px solid #23263a'}}>
                                        <div style={{fontSize:'13px', color:'#c8cbe0', marginBottom:'6px'}}>{lado==='elimina_se_sim' ? 'Se a resposta for SIM, eliminar as perguntas:' : 'Se a resposta for NAO, eliminar as perguntas:'}</div>
                                        <div style={{display:'flex', flexWrap:'wrap', gap:'8px'}}>
                                            {form.perguntas.map((q, j) => j===i ? null : (
                                                <label key={j} style={{display:'flex', alignItems:'center', gap:'4px', fontSize:'12px', color:'#8b8fa3', background:'#141625', border:'1px solid #23263a', borderRadius:'6px', padding:'3px 8px', cursor:'pointer'}}>
                                                    <input type="checkbox" checked={(p[lado]||[]).includes(j+1)} onChange={()=>toggleElimina(i, lado, j+1)}/>
                                                    {(j+1) + (q.rotulo ? ' - ' + q.rotulo.slice(0,25) : '')}
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                                <div style={{marginTop:'8px', paddingTop:'8px', borderTop:'1px solid #23263a'}}>
                                    <div style={{fontSize:'13px', color:'#c8cbe0', marginBottom:'6px'}}>Reter a ficha (nao enviar ao humano) quando a resposta desta pergunta for:</div>
                                    <div style={{display:'flex', gap:'16px', marginBottom:'8px'}}>
                                        <label style={{display:'flex', alignItems:'center', gap:'4px', fontSize:'12px', color:'#8b8fa3', cursor:'pointer'}}>
                                            <input type="checkbox" checked={!!p.reter_se_sim} onChange={e=>setPergunta(i,'reter_se_sim',e.target.checked)}/> SIM
                                        </label>
                                        <label style={{display:'flex', alignItems:'center', gap:'4px', fontSize:'12px', color:'#8b8fa3', cursor:'pointer'}}>
                                            <input type="checkbox" checked={!!p.reter_se_nao} onChange={e=>setPergunta(i,'reter_se_nao',e.target.checked)}/> NAO
                                        </label>
                                    </div>
                                    {(p.reter_se_sim || p.reter_se_nao) && (
                                        <input placeholder="O que o agente diz ao encerrar (ex: agradeca e diga que vai verificar outra opcao)" value={p.retencao_instrucao||''} onChange={e=>setPergunta(i,'retencao_instrucao',e.target.value)}
                                            style={{width:'100%', padding:'8px', borderRadius:'6px', background:'#141625', border:'1px solid #23263a', color:'#fff', boxSizing:'border-box'}}/>
                                    )}
                                </div>
                            </div>
                        ))}
                        <button onClick={addPergunta} style={{background:'transparent', border:'1px dashed #6c5ce7', color:'#6c5ce7', borderRadius:'8px', padding:'8px 14px', cursor:'pointer', marginBottom:'16px'}}>+ Pergunta</button>

                        <label style={{display:'block', marginBottom:'6px', fontSize:'14px', color:'#c8cbe0'}}>Instrucao final ao agente (opcional)</label>
                        <textarea value={form.instrucao_final} onChange={e=>setForm({...form, instrucao_final:e.target.value})} rows={2}
                            placeholder="Ex: Agradeca em nome da Central de Vendas."
                            style={{width:'100%', padding:'10px', borderRadius:'8px', background:'#0d0f1a', border:'1px solid #23263a', color:'#fff', marginBottom:'16px', boxSizing:'border-box', resize:'vertical'}}/>

                        <label style={{display:'flex', alignItems:'center', gap:'8px', marginBottom:'20px', cursor:'pointer'}}>
                            <input type="checkbox" checked={form.ativo} onChange={e=>setForm({...form, ativo:e.target.checked})}/>
                            Formulario ativo (o agente coleta e envia a ficha)
                        </label>

                        <div style={{display:'flex', justifyContent:'flex-end', gap:'10px'}}>
                            <button onClick={()=>setShowModal(false)} style={{background:'transparent', border:'1px solid #23263a', borderRadius:'8px', padding:'10px 16px', color:'#c8cbe0', cursor:'pointer'}}>Cancelar</button>
                            <button onClick={salvar} disabled={salvando} style={{background:'#6c5ce7', border:'none', borderRadius:'8px', padding:'10px 20px', color:'#fff', cursor:'pointer', fontWeight:600}}>{salvando ? 'Salvando...' : 'Salvar'}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
